import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FilterCriteriaService } from '../../services/filter-criteria.service';
import { SelectedColumn } from '../../../models/user-info.model';
import { ShareModule } from '../../share.module';
import { Notification } from '../../notification/notification.component';

@Component({
  selector: 'app-configure-columns',
  imports: [ShareModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './configure-columns.component.html',
  styleUrl: './configure-columns.component.scss',
})
export class ConfigureColumnsComponent implements OnInit {
  columnAvailable: string[] = [];
  selectedColumns: string[] = [];
  isLoadingForConfigurableColumns = false;
  selectedAvailable: string[] = [];
  selectedSelected: string[] = [];
  isSaveLoading = false;
  @Input() notification!: Notification;
  @Output() notificationChange = new EventEmitter<Notification>();
  constructor(private filterCriteriaService: FilterCriteriaService) {}

  ngOnInit() {
    this.isLoadingForConfigurableColumns = true;
    this.filterCriteriaService
      .viewConfigurableColumns()
      .subscribe((columns) => {
        this.selectedColumns = columns.selectedColumn?.selectedColumns?? [];
        this.columnAvailable = columns.columnAvailable
          .map((col) => col.columnName)
          .filter((col) => !this.selectedColumns.includes(col));
        this.isLoadingForConfigurableColumns = false;
      });
  }

  toggleAvailable(col: string) {
    if (this.selectedAvailable.includes(col)) {
      this.selectedAvailable = this.selectedAvailable.filter((c) => c !== col);
    } else {
      this.selectedAvailable.push(col);
    }
  }

  toggleSelected(col: string) {
    if (this.selectedSelected.includes(col)) {
      this.selectedSelected = this.selectedSelected.filter((c) => c !== col);
    } else {
      this.selectedSelected.push(col);
    }
  }

  moveToSelected() {
    this.selectedAvailable.forEach((col) => {
      this.selectedColumns.push(col);
      this.columnAvailable = this.columnAvailable.filter((c) => c !== col);
    });

    this.selectedAvailable = [];
  }

  moveToAvailable() {
    this.selectedSelected.forEach((col) => {
      this.columnAvailable.push(col);
      this.selectedColumns = this.selectedColumns.filter((c) => c !== col);
    });

    this.selectedSelected = [];
  }

  saveSelectedColumns() {
    this.isSaveLoading = true;
    const payload: SelectedColumn = {
      selectedColumns: this.selectedColumns,
    };

    this.filterCriteriaService.saveSelectedColumns(payload).subscribe({
      next: (response) => {
        this.isSaveLoading = false;
        this.notification = {
          label: 'Success',
          description: response.message,
          type: 'success',
        };
        this.notificationChange.emit(this.notification);
      },
      error: (err) => {
        this.isSaveLoading = false;
        this.notification = {
          label: 'Error',
          description:
            err.error?.error ||
            'Failed to save selected columns. Please try again.',
          type: 'error',
        };
        this.notificationChange.emit(this.notification);
      },
    });
  }
}
